module.exports = __webpack_public_path__ + "static/media/bluefin-tuna.2070abf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/bluefin-tuna.png
// module id = 304
// module chunks = 0